import Switch from "@mui/material/Switch";
import { observer } from "mobx-react-lite";
import { CompanyMinLocationCount, ICompanyFilterSettings } from "../../interfaces/IFilterSettings";
import styles from "./GlobalFilters.module.css";

function GlobalFiltersCompaniesTab({ companyFiltersState, setCompanyFiltersState }: IGlobalFiltersCompaniesTabProps) {
    return (
        <div className={styles.columns}>
            <div className={styles.switchesSection}>
                DISPLAY OPTIONS
                <div>
                    <label className={styles.switchRow}>
                        <span className={styles.switchLabel}>Show Sale Comps</span>
                        <Switch
                            checked={companyFiltersState.includeSaleComps}
                            onChange={e => setCompanyFiltersState({
                                ...companyFiltersState,
                                includeSaleComps: e.target.checked,
                            })}
                        />
                    </label>
                    <label className={styles.switchRow}>
                        <span className={styles.switchLabel}>Show Lease Comps</span>
                        <Switch
                            checked={companyFiltersState.includeLeaseComps}
                            onChange={e => setCompanyFiltersState({
                                ...companyFiltersState,
                                includeLeaseComps: e.target.checked,
                            })}
                        />
                    </label>
                    <label className={styles.switchRow}>
                        <span className={styles.switchLabel}>Hide Duplicate Locations</span>
                        <Switch
                            checked={companyFiltersState.hideDuplicateLocations}
                            onChange={e => setCompanyFiltersState({
                                ...companyFiltersState,
                                hideDuplicateLocations: e.target.checked,
                            })}
                        />
                    </label>
                </div>
            </div>
            <div className={styles.switchesSection}>
                VIEW ALL OPTIONS
                <div>
                    <label className={styles.switchRow}>
                        <span className={styles.switchLabel}>Minimum Location Count</span>
                        <select value={companyFiltersState.minLocationCount} onChange={e => setCompanyFiltersState({
                            ...companyFiltersState,
                            minLocationCount: e.target.value as CompanyMinLocationCount,
                        })}>
                            <option value={CompanyMinLocationCount.All}>All</option>
                            <option value={CompanyMinLocationCount.Ten}>10+</option>
                            <option value={CompanyMinLocationCount.TwentyFive}>25+</option>
                            <option value={CompanyMinLocationCount.Fifty}>50+</option>
                            <option value={CompanyMinLocationCount.OneHundred}>100+</option>
                        </select>
                    </label>
                    <label className={styles.switchRow}>
                        <span className={styles.switchLabel}>Hide Companies w/o Logos</span>
                        <Switch
                            checked={companyFiltersState.hideNoLogoCompany}
                            onChange={e => setCompanyFiltersState({
                                ...companyFiltersState,
                                hideNoLogoCompany: e.target.checked,
                            })}
                        />
                    </label>
                </div>
            </div>
        </div>
    );
}

export default observer(GlobalFiltersCompaniesTab);

interface IGlobalFiltersCompaniesTabProps {
    companyFiltersState: ICompanyFilterSettings;
    setCompanyFiltersState: (state: ICompanyFilterSettings) => void;
}